let constants: Record<string, string>;

export default (app_init?: Record<string, string>) => {
  if (!constants) constants = app_init;
  return constants || {};
};
